import { render, staticRenderFns } from "./UpcomingFeatures.vue?vue&type=template&id=4a8a669c&scoped=true"
import script from "./UpcomingFeatures.vue?vue&type=script&setup=true&lang=js"
export * from "./UpcomingFeatures.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8a669c",
  null
  
)

export default component.exports